enum Permission {
    Restricted = 512,
    Read = 4,
    Write = 8,
    Delete = 16,
    Designer = 63,
    Admin = 255
}

export default Permission;